export const SEARCH_ESTIMATES_LOADING = "app/SEARCH_ESTIMATES_LOADING";
export const SEARCH_ESTIMATES_RESULTS = "app/SEARCH_ESTIMATES_RESULTS";